import useSiteConfig from "@casino/legacy/client/hooks/useSiteConfig";

const useTermsUrl = () => {
  const { termsAndConditionsLink } = useSiteConfig();
  return termsAndConditionsLink;
};

export default useTermsUrl;
